import { useTranslation } from "react-i18next";
import { Coins, Mic2, Users } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";

const num = (value) => (value || 0).toLocaleString("en-US");
const LOW_PERCENT = 20;

// عدّاد استهلاك التحيات الصوتية ورصيد حساب ElevenLabs.
export const VoiceUsageCard = ({ usage, balance, provider }) => {
  const { t } = useTranslation();
  const percent = balance?.limit ? Math.round((balance.remaining * 100) / balance.limit) : null;
  const low = percent !== null && percent <= LOW_PERCENT;
  const rows = [
    [Mic2, t("greeting.usageGenerated"), num(usage?.generated)],
    [Users, t("greeting.usageEmployees"), num(usage?.employees)],
    [Coins, t("greeting.usageCredits"), num(usage?.credits_used_est)],
    [
      Coins,
      t("greeting.usageRemaining"),
      balance?.available ? `${num(balance.remaining)} / ${num(balance.limit)}` : "—",
    ],
  ];

  return (
    <NeuCard data-testid="voice-usage-card">
      <p className="label-xs">{t("greeting.usageTitle")}</p>
      <p className="mt-2 text-xs text-muted-foreground">
        {t("greeting.usageProvider")}: <span className="font-bold text-primary">{provider || "—"}</span>
        {balance?.tier ? ` · ${balance.tier}` : ""}
      </p>
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        {rows.map(([Icon, label, value]) => (
          <div key={label} className="flex items-center justify-between gap-2 rounded-2xl px-3 py-2 shadow-neu-sm">
            <span className="flex items-center gap-2 text-[11px] text-muted-foreground">
              <Icon className="h-3.5 w-3.5" /> {label}
            </span>
            <span className="font-mono text-sm font-bold">{value}</span>
          </div>
        ))}
      </div>
      {low ? (
        <p className="mt-3 rounded-2xl bg-destructive/10 px-3 py-2 text-[11px] font-bold text-destructive" data-testid="voice-low-balance">
          {t("greeting.lowBalance", { percent })}
        </p>
      ) : null}
    </NeuCard>
  );
};
